import { useCallback, useEffect, useMemo, useState } from "react";
import { EMPTY_SELECTION, countSelected, deselectPage as deselectPageRows, isPageSelected, isRowSelected as isRowInSelection, selectAcrossFilter, selectPage as selectPageRows, toggleRow as toggleSelectionRow, } from "../utils/selectionState";
import { selectionTotal } from "../utils/selectionTotal";
export function useSelection(_a) {
    var pageIds = _a.pageIds, totalCount = _a.totalCount, exactTotalCount = _a.exactTotalCount, isCountCapped = _a.isCountCapped, filterDeps = _a.filterDeps;
    var _b = useState(EMPTY_SELECTION), state = _b[0], setState = _b[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(function () { return setState(EMPTY_SELECTION); }, filterDeps);
    var isAllPageSelected = useMemo(function () { return isPageSelected(state, pageIds); }, [state, pageIds]);
    var selectPage = useCallback(function () { return setState(function (prev) { return selectPageRows(prev, pageIds); }); }, [pageIds]);
    var deselectPage = useCallback(function () { return setState(function (prev) { return deselectPageRows(prev, pageIds); }); }, [pageIds]);
    var togglePage = useCallback(function () { return (isAllPageSelected ? deselectPage() : selectPage()); }, [isAllPageSelected, deselectPage, selectPage]);
    var selectAllAcrossFilter = useCallback(function () { return setState(selectAcrossFilter()); }, []);
    var clearSelection = useCallback(function () { return setState(EMPTY_SELECTION); }, []);
    var toggleRow = useCallback(function (id) { return setState(function (prev) { return toggleSelectionRow(prev, id); }); }, []);
    var isRowSelected = useCallback(function (id) { return isRowInSelection(state, id); }, [state]);
    var selectedCount = useMemo(function () {
        return countSelected(state, selectionTotal(totalCount, exactTotalCount, isCountCapped !== null && isCountCapped !== void 0 ? isCountCapped : false));
    }, [state, totalCount, exactTotalCount, isCountCapped]);
    return {
        mode: state.mode,
        includeIds: state.includeIds,
        excludeIds: state.excludeIds,
        isAllPageSelected: isAllPageSelected,
        isRowSelected: isRowSelected,
        selectPage: selectPage,
        deselectPage: deselectPage,
        togglePage: togglePage,
        selectAllAcrossFilter: selectAllAcrossFilter,
        clearSelection: clearSelection,
        toggleRow: toggleRow,
        selectedCount: selectedCount,
    };
}
